// Alternative-date suggestions built from the provider's widened date-window
// search (by_time_window bucket), one entry per outbound/return day pair.

const day_of = (datetime) => (datetime || '').split('T')[0];

const date_pair = (offer, return_flight) => {
  const { firstDeparture = {}, lastDeparture = {}, oneWay } = offer || {};
  return {
    in: day_of(firstDeparture.at),
    out: return_flight && !oneWay ? day_of(lastDeparture.at) : '',
  };
};

/**
 * Cheapest offer per (outbound day, return day) pair, sorted by date.
 * @param {FlightOffer[]} offers
 * @param {boolean} return_flight
 * @returns {{in: string, out: string, min_price: number, currency: string,
 *   currencySymbol: string, flight_offer: FlightOffer}[]}
 */
export const build_date_suggestions = (offers, return_flight) => {
  const cheapest = {};
  (Array.isArray(offers) ? offers : []).forEach((offer) => {
    const pair = date_pair(offer, return_flight);
    const key = `${pair.in}/${pair.out}`;
    const current = cheapest[key];
    if (!current || Number(offer.price.grandTotal) < Number(current.offer.price.grandTotal)) {
      cheapest[key] = { pair, offer };
    }
  });

  return Object.values(cheapest)
    .map(({ pair, offer }) => ({
      ...pair,
      min_price: offer.price.grandTotal,
      currency: offer.price.currency,
      currencySymbol: offer.price.currencySymbol,
      flight_offer: offer,
    }))
    .sort((a, b) => a.in.localeCompare(b.in) || a.out.localeCompare(b.out));
};

/**
 * Index of the suggestion matching the dates of the committed search, -1 if none.
 * @param {Object[]} suggestions - build_date_suggestions output
 * @param {Object} search_request
 * @returns {number}
 */
export const find_selected_date_suggestion = (suggestions, search_request) => {
  const { originDestinations = [] } = search_request || {};
  const [date_in = '', date_out = ''] = originDestinations.map(
    ({ departureDateTimeRange = {} }) => departureDateTimeRange.date || ''
  );
  if (!date_in) return -1;
  return suggestions.findIndex(
    (s) => s.in === date_in && (!s.out || s.out === date_out)
  );
};
